<template>
  <v-container fluid>
    <v-card>
      <v-card-title class="text-center teal lighten-3 accent-4 white--text">
        Precios <v-spacer></v-spacer>
        <v-text-field
          class="mt-4"
          v-model="search"
          append-icon="mdi-magnify"
          label="Búsqueda"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-spacer />
        <v-btn class="mt-7" color="primary" dark @click="dialogExcel = true">
          Subir Excel
        </v-btn>
      </v-card-title>

      <v-dialog v-model="dialogExcel" max-width="520">
        <v-card>
          <v-card-title class="headline">Subir Excel</v-card-title>
          <v-card-text>
            <v-file-input
              v-model="excelFile"
              accept=".xlsx, .xls"
              label="Selecciona un archivo Excel"
              prepend-icon="mdi-file-excel"
              dense
              show-size
              :disabled="loadingExcel"
            />
            <div v-if="loadingExcel" class="mt-4">
              <div class="d-flex justify-space-between align-center mb-2">
                <span class="font-weight-bold">Subiendo...</span>
                <span class="font-weight-bold"
                  >{{ uploadProgress.current }} de
                  {{ uploadProgress.total }}</span
                >
              </div>
              <v-progress-linear
                :value="(uploadProgress.current / uploadProgress.total) * 100"
                color="primary"
                height="8"
              />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="dialogExcel = false" :disabled="loadingExcel">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              :disabled="!excelFile || loadingExcel"
              @click="submitExcelFile"
              :loading="loadingExcel"
            >
              Subir
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogResults" max-width="700">
        <v-card>
          <v-card-title class="headline">Resultados de la Carga</v-card-title>
          <v-card-text>
            <div class="mb-4">
              <v-chip color="green" text-color="white" class="mr-2">
                Exitosos: {{ resultsData.successful.length }}
              </v-chip>
              <v-chip
                v-if="resultsData.errors.length > 0"
                color="red"
                text-color="white"
              >
                Errores: {{ resultsData.errors.length }}
              </v-chip>
            </div>

            <v-row class="mb-4">
              <v-col cols="12" sm="6">
                <v-checkbox
                  v-model="showResultSuccessful"
                  label="Mostrar correctos"
                  color="green"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-checkbox
                  v-model="showResultErrors"
                  label="Mostrar errores"
                  color="red"
                />
              </v-col>
            </v-row>

            <v-data-table
              v-if="filteredResults.length"
              :headers="resultHeaders"
              :items="filteredResults"
              class="elevation-1"
              :items-per-page="15"
              :footer-props="{
                'items-per-page-text': 'Resultados por página',
              }"
              :header-props="{
                'sort-by-text': 'Ordenar por',
              }"
            >
              <template v-slot:[`item.state`]="{ item }">
                <v-chip
                  :color="item.state === 'Correcto' ? 'green' : 'red'"
                  dark
                  small
                >
                  {{ item.state }}
                </v-chip>
              </template>
            </v-data-table>

            <div v-else class="text-center grey--text">
              No hay registros de resultado para mostrar.
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="dialogResults = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-data-table
        :headers="headers"
        :items="productos"
        :search="search"
        :items-per-page="15"
        :footer-props="{
          'items-per-page-text': 'Productos por página',
        }"
        :header-props="{
          'sort-by-text': 'Ordenar por',
        }"
      >
        <template v-slot:[`item.precio_especial`]="{ item }">
          <span v-if="item.precio_especial == null" style="font-size: 12px">
            Sin precio especial
          </span>

          <span v-else>
            {{ "$" + item.precio_especial.toFixed(2) }}
          </span>
        </template>
        <template v-slot:[`item.precio_exclusivo`]="{ item }">
          <span v-if="item.precio_exclusivo == null" style="font-size: 12px">
            Sin precio exclusivo
          </span>

          <span v-else>
            {{ "$" + item.precio_exclusivo.toFixed(2) }}
          </span>
        </template>
        <template v-slot:[`item.precio_select`]="{ item }">
          <span v-if="item.precio_select == null" style="font-size: 12px">
            Sin precio select
          </span>

          <span v-else>
            {{ "$" + item.precio_select.toFixed(2) }}
          </span>
        </template>
        <template v-slot:[`item.precio_prostasa`]="{ item }">
          <span v-if="item.precio_prostasa == null" style="font-size: 12px">
            Sin precio prostasa
          </span>

          <span v-else>
            {{ "$" + item.precio_prostasa.toFixed(2) }}
          </span>
        </template>
        <template v-slot:[`item.precio_gobierno`]="{ item }">
          <span v-if="item.precio_gobierno == null" style="font-size: 12px">
            Sin precio gobierno
          </span>

          <span v-else>
            {{ "$" + item.precio_gobierno.toFixed(2) }}
          </span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import ExcelJS from "exceljs";

export default {
  props: [],
  components: {},
  data() {
    return {
      valid: true,
      productos: [],
      search: "",
      dialogExcel: false,
      loadingExcel: false,
      excelFile: null,
      uploadProgress: { current: 0, total: 0 },
      dialogResults: false,
      resultsData: {
        successful: [],
        errors: [],
      },
      resultsTable: [],
      showResultSuccessful: true,
      showResultErrors: true,
      resultHeaders: [
        { text: "ID de Producto", value: "idProducto" },
        { text: "Código de Producto", value: "productCode" },
        { text: "ID lista de precios", value: "idListaPrecios" },
        { text: "Precio", value: "precio" },
        { text: "Estado", value: "state" },
      ],
      headers: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Código",
          value: "codigo_producto",
        },
        {
          text: "Precio Especial (MXN)",
          value: "precio_especial",
        },
        {
          text: "Precio Exclusivo (MXN)",
          value: "precio_exclusivo",
        },
        {
          text: "Precio Select (MXN)",
          value: "precio_select",
        },
        {
          text: "Precio Prostasa (MXN)",
          value: "precio_prostasa",
        },
        {
          text: "Precio Gobierno (MXN)",
          value: "precio_gobierno",
        },
      ],
      priceTypes: [
        { id: 2, key: "precio_especial" },
        { id: 3, key: "precio_exclusivo" },
        { id: 4, key: "precio_select" },
        { id: 5, key: "precio_prostasa" },
        { id: 6, key: "precio_gobierno" },
      ],
    };
  },
  methods: {
    async getListaPrecios() {
      try {
        const responses = await Promise.all(
          this.priceTypes.map((pt) =>
            axios.get(
              `/odoo/get_precios_de_lista_de_precios?id_lista_de_precios=${pt.id}`,
            ),
          ),
        );

        const priceMaps = {};
        this.priceTypes.forEach((pt, index) => {
          const data = responses[index].data;
          const headers = data.headers;
          const rows = data.data;
          const map = {};
          rows.forEach((row) => {
            const obj = {};
            headers.forEach((header, idx) => {
              obj[header] = row[idx];
            });
            map[obj.id] = obj.precio;
          });
          priceMaps[pt.key] = map;
        });

        // Assign to productos
        this.productos.forEach((producto) => {
          const id = producto.id;
          this.priceTypes.forEach((pt) => {
            producto[pt.key] = priceMaps[pt.key][id];
          });
        });
      } catch (error) {
        console.error(error);
      }
    },

    async getProductos() {
      try {
        const productos = await axios.get("/odoo/get_productos");

        const headers = productos.data.headers;
        const rows = productos.data.data;

        this.productos = rows.map((row) => {
          let obj = {};
          headers.forEach((header, index) => {
            obj[header] = row[index];
          });
          return obj;
        });
        this.productos.sort((a, b) => a.id - b.id);
      } catch (error) {
        console.error(error);
      }
    },
    submitExcelFile() {
      if (!this.excelFile) {
        console.warn("Selecciona un archivo antes de subir.");
        return;
      }
      this.uploadExcelFile(this.excelFile);
    },

    async uploadExcelFile(file) {
      this.loadingExcel = true;
      try {
        const workbook = new ExcelJS.Workbook();
        const arrayBuffer = await file.arrayBuffer();
        await workbook.xlsx.load(arrayBuffer);

        const worksheet = workbook.worksheets[0];
        if (!worksheet) {
          throw new Error("El archivo Excel no tiene ninguna hoja.");
        }

        const headerRow = worksheet.getRow(1);
        const headers = headerRow.values
          .slice(1)
          .map((value) => String(value || "").trim());

        if (headers.length < 2) {
          throw new Error(
            "El Excel debe tener al menos columna de producto y una columna de precio.",
          );
        }

        // Mapear nombres de columnas a IDs de listas de precios
        const priceNameToId = {
          precio_especial: 2,
          precio_exclusivo: 3,
          precio_select: 4,
          precio_prostasa: 5,
          precio_gobierno: 6,
        };

        // Mapear códigos de producto a IDs
        const productByCode = this.productos.reduce((map, item) => {
          const code = String(item.codigo_producto || "").trim();
          if (code) {
            map[code] = item.id;
          }
          return map;
        }, {});

        const requests = [];
        const requestMetadata = [];
        let missingProducts = 0;

        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
          if (rowNumber === 1) {
            return;
          }

          const rowValues = row.values.slice(1).map((value) => {
            const v = value === undefined || value === null ? "" : value;
            if (v && typeof v === "object") {
              if (Object.prototype.hasOwnProperty.call(v, "result"))
                return v.result;
              if (Object.prototype.hasOwnProperty.call(v, "text"))
                return v.text;
              if (Array.isArray(v.richText))
                return v.richText.map((t) => t.text).join("");
              try {
                return String(v);
              } catch (e) {
                return "";
              }
            }
            return v;
          });
          const productCode = String(rowValues[0] || "").trim();
          const idProducto = productByCode[productCode];

          if (!productCode || !idProducto) {
            missingProducts += 1;
            return;
          }

          // Primera columna es código, las demás son nombres de precios
          for (
            let columnIndex = 1;
            columnIndex < rowValues.length;
            columnIndex += 1
          ) {
            const priceColumnName = headers[columnIndex];
            const idListaPrecios = priceNameToId[priceColumnName];
            const precioRaw = rowValues[columnIndex];

            // Validar que sea un nombre de precio válido
            if (!idListaPrecios || !priceColumnName) {
              continue;
            }

            if (
              precioRaw === "" ||
              precioRaw === null ||
              precioRaw === undefined
            ) {
              continue;
            }

            // Normalizar posibles objetos devueltos por ExcelJS (formula, richText, etc.)
            let precioNormalized = precioRaw;
            if (precioNormalized && typeof precioNormalized === "object") {
              if (
                Object.prototype.hasOwnProperty.call(precioNormalized, "result")
              )
                precioNormalized = precioNormalized.result;
              else if (
                Object.prototype.hasOwnProperty.call(precioNormalized, "text")
              )
                precioNormalized = precioNormalized.text;
              else if (Array.isArray(precioNormalized.richText))
                precioNormalized = precioNormalized.richText
                  .map((t) => t.text)
                  .join("");
              else precioNormalized = String(precioNormalized);
            }

            const precioNumber = parseFloat(precioNormalized);
            if (Number.isNaN(precioNumber)) {
              continue;
            }

            const metadata = {
              idProducto,
              productCode,
              idListaPrecios: parseInt(idListaPrecios),
              precio: precioNumber,
            };
            requestMetadata.push(metadata);
            requests.push(
              axios
                .post(
                  `/odoo/set_precio_de_producto_en_lista_de_precios?id_producto=${idProducto}&id_lista_de_precios=${idListaPrecios}&precio=${precioNumber}`,
                )
                .then(() => {
                  this.uploadProgress.current += 1;
                }),
            );
          }
        });

        if (requests.length === 0) {
          console.warn(
            "No se encontraron valores para enviar en el archivo Excel.",
          );
          this.dialogResults = true;
          return;
        }

        this.uploadProgress.total = requests.length;
        this.uploadProgress.current = 0;

        const results = await Promise.allSettled(requests);
        this.resultsData = { successful: [], errors: [] };
        this.resultsTable = [];

        results.forEach((result, index) => {
          const metadata = requestMetadata[index];
          if (result.status === "fulfilled") {
            const row = { ...metadata, state: "Correcto" };
            this.resultsData.successful.push(metadata);
            this.resultsTable.push(row);
          } else {
            const row = {
              ...metadata,
              state: "Error",
              message: result.reason?.message || "Error desconocido",
            };
            this.resultsData.errors.push(row);
            this.resultsTable.push(row);
          }
        });

        console.info(
          `Excel procesado: ${this.resultsData.successful.length} exitosos, ${this.resultsData.errors.length} errores, ${missingProducts} filas sin producto válido.`,
        );
      } catch (error) {
        console.error("Error al procesar el Excel:", error);
        this.resultsData = {
          successful: [],
          errors: [{ message: error.message }],
        };
      } finally {
        this.excelFile = null;
        this.loadingExcel = false;
        this.uploadProgress = { current: 0, total: 0 };
        this.dialogExcel = false;
        this.dialogResults = true;
        await this.getProductos();
        await this.getListaPrecios();
      }
    },
  },

  async mounted() {
    await this.getProductos();
    await this.getListaPrecios();
  },
  computed: {
    filteredResults() {
      return this.resultsTable.filter((item) => {
        if (item.state === "Correcto" && this.showResultSuccessful) {
          return true;
        }
        if (item.state === "Error" && this.showResultErrors) {
          return true;
        }
        return false;
      });
    },
  },
};
</script>
